// Required
export const CUSTUMER_NAME_REQUIRED = 'Customer Name is Required';
export const ADDRESS_REQUIRED = 'Address is Required';
export const PINCODE_REQUIRED = 'Pincode is Required';
export const CUSTUMER_CODE_REQUIRED = 'Customer Code is Required';

// Invalid 
export const INVALID_PAN_NO = 'Invalid Pan No.';
export const INVALID_GST_NUMBER = 'Invalid GST Number';
export const INVALID_MOBILE_NUMBER = 'Invalid Mobile Number.';
export const INVALID_DRIVING_LICENCE = 'Invalid Driving Licence.';
export const INVALID_BANK_ACC_NUMBER = 'Invalid Account No';
export const INVALID_BANK_IFSC = 'Invalid Bank IFSC Code.';
export const INVALID_ADHAR_NO = 'Invalid Aadhar No.';
export const INVALID_RESIDENCE_ADDRESS = 'Invalid Resident Address';
export const INVALID_PERMENET_ADDRESS = 'Invalid Permenet Address';
export const INVALID_ALTERNET_NAME = 'Invalid Alternate Name';
export const INVALID_MOBILE_NO = 'Invalid Mobile No.';
export const INVALID_GUARANTOR_NAME = 'Invalid Guarantor Name';
export const INVALID_GUARANTOR_MOBILE_NO = 'Invalid Guarantor Mobile No.';
export const FIELD_IS_REQUIRED = 'Field is required.';
export const INVALID_PIN_CODE = 'Invalid Pin code';
export const INVALID_BANK_NAME = 'Invalid Bank name';
export const INVALID_NAME = 'Invalid Name';
export const INVALID_LAND_LINE_NUMBER = 'Invalid Land line number';
export const INVALID_EMAIL = 'Invalid Email';
export const INVALID_LATITUDE = 'Invalid Latitude';
export const INVALID_LONGITUDE = 'Invalid Longitude';

// Min Validation
export const MORE_THEN_THREE = 'Should be more than 3 characters';
export const INVALID_TARGET_MONTH = 'Target is already set for this month';

export const INVALID_FIELD = {
    INVALID_ADDRESS: 'Invalid Address.'
}

export const TOAST_MESSAGES = {
    DELETE_SUCCESS : "Deleted Successfully.",
    CANT_CHANGE_IN_CURRENT_FINANCIAL_YEAR : (field)=> `${field} can only be changed after the validity end date expired.`
}

export const ERROR_MESSAGES = {
    INVALID_PAN_NO,
    INVALID_GST_NUMBER,
    INVALID_NUMBER: 'Invalid Number',
    INVALID_MOBILE_NUMBER,
    INVALID_DRIVING_LICENCE,
    INVALID_BANK_ACC_NUMBER,
    INVALID_BANK_IFSC,
    INVALID_ADHAR_NO,
    INVALID_RESIDENCE_ADDRESS,
    INVALID_PERMENET_ADDRESS,
    INVALID_ALTERNET_NAME,
    INVALID_MOBILE_NO,
    INVALID_GUARANTOR_NAME,
    INVALID_GUARANTOR_MOBILE_NO,
    FIELD_IS_REQUIRED,
    INVALID_PIN_CODE,
    INVALID_BANK_NAME,
    INVALID_NAME,
    INVALID_LAND_LINE_NUMBER,
    INVALID_EMAIL,
    INVALID_LATITUDE,
    INVALID_LONGITUDE,
    INVALID_BANK_ACCOUNT_NO: 'Invalid Bank account Number',
    INVALID_IFSC_CODE: 'Invalid IFSC Code',
    INVALID_LAND_LINE: 'Invalid Landline number',
    INVALID_ADDRESS: 'Invalid Address',
    INVALID_PINCODE: 'Invalid Pin code',
    VENDOR_NAME_REQUIRED: 'Vendor Name is Required',
    CUSTOMER_NAME_REQUIRED: 'Customer Name is Required',
    BRANCH_REQUIRED: 'Branch is Required',
    PAYMENT_AMOUNT_REQUIRED: 'Payment Amount is Required',
    PAYMENT_MODE_REQUIRED: 'Payment Mode is Required',
    PAYMENT_DATE_REQUIRED: 'Payment Date is Required',
    REFERENCE_NO_REQUIRED: 'Reference No is Required',
    TRANSACTION_DATE_REQUIRED: 'Transaction Date is Required',
    AMOUNT_LESS_THAN_ZERO: 'Amount should be greater than zero',
    AMOUNT_DUE_EXCEEDED_PAYMENT_PLUS_TDS: "Payment + TDS cannot exceed Amount Due",
    INVALID_MAXSIZE : "Entered value size is greater than maximum allowed size",
    INVALID_MAXIMUMSIZE : (len)=> `Maximum length is ${len}`,
    NO_DATA_FOUND : 'No Data Found',
    INVALID_FIELD : (field)=> `Invalid ${field}`
}